import { Button, Collapse, Divider, Drawer, List } from "antd";
import { useEffect, useState } from "react";
import logo from "../../Images/Logo.png";
import { GrClose } from "react-icons/gr";
import NavigationLinks from "./NavigationLinks";
import { NavLink, useLocation } from "react-router-dom";
import "../../Css/Navbar.css";
import { FaAngleDown, FaBriefcase } from "react-icons/fa6";
import { RxHamburgerMenu } from "react-icons/rx";
import { get } from "../../services/ApiRouting";

export default function LeftDrawerNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    setOpen(false);
  }, [location]);

  return (
    <>
      <Button className="toggle-button d-block d-xl-none" onClick={showDrawer}>
        <RxHamburgerMenu style={{ fontSize: "2rem" }} />
      </Button>

      <Drawer
        title=""
        placement={"right"}
        width={500}
        closable={false}
        onClose={onClose}
        open={open}
        key={"left"}
        className="left-drawer-nav"
      >
        <div className="sidebar-list">
          <div className="sidebar-header flex justify-between items-center">
            <div className="d-flex justify-content-center align-items-center">
              <img
                style={{ width: 140, marginRight: 10 }}
                src={logo}
                alt="logo"
              />
            </div>
            <Button
              onClick={onClose}
              icon={<GrClose style={{ color: "red" }} />}
              style={{
                background: "#fff",
                borderRadius: "100px",
                width: 35,
                height: 35,
                boxShadow: "unset",
              }}
            />
          </div>
          <Divider />
          <List
            dataSource={NavigationLinks}
            renderItem={(item) => (
              <List.Item className="sidebar-list-item w-100">
                {Array.isArray(item?.link) ? (
                  <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => (
                      <FaAngleDown
                        className="angle-down"
                        rotate={isActive ? 90 : 0}
                      />
                    )}
                    defaultActiveKey={["1"]}
                    style={{ padding: 0, width: "100%", background: "#fff" }}
                    key={item?.name}
                    expandIconPosition="right"
                    items={[
                      {
                        label: (
                          <div className="collapse-text">
                            {item?.prefix}{" "}
                            <h5 className="header-drawer-nav-link">
                              {item?.name}
                            </h5>
                          </div>
                        ),
                        children: <DropDownList nav={item?.name} item={item} />,
                      },
                    ]}
                  />
                ) : (
                  <List.Item.Meta
                    avatar={
                      <NavLink
                        to={item?.link}
                        className="header-drawer-nav-link flex items-center justify-center"
                      >
                        {item?.prefix}
                      </NavLink>
                    }
                    title={
                      <NavLink
                        to={item?.link}
                        className="header-drawer-nav-link"
                      >
                        {item?.name}
                      </NavLink>
                    }
                  />
                )}
              </List.Item>
            )}
          />
          <Divider />
          <Button
            style={{
              borderRadius: 0,
              height: 40,
              background: "var(--primaryColor)",
              borderColor: "var(--primaryColor)",
              color: "#fff",
              width: "100%",
            }}
            icon={<FaBriefcase />}
          >
            Are you vendor ?
          </Button>
        </div>
      </Drawer>
    </>
  );
}

const DropDownList = ({ nav, item }) => {
  const [navigation, setNavigation] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [venues, setVenues] = useState([]);
  const [cast, setCast] = useState([]);
  const [event, setEvent] = useState([]);

  const getVenues = async () => {
    try {
      const resp = await get("subcategories");
      setVenues(resp?.data);
      return resp;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getVendors = async () => {
    try {
      const resp = await get("categories");
      setVendors(resp?.data);
      return resp;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  const getCommunities = async (type) => {
    try {
      const resp = await get("communities?type=" + type);
      if (type === 1) {
        setCast(resp?.data);
      }

      if (type === 0) {
        setEvent(resp?.data || []);
      }
      return resp;
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  useEffect(() => {
    (async () => {
      switch (nav) {
        case "Venues":
          if (venues?.length > 0) {
            setNavigation(
              venues?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=venue" + "&subcategory=" + val.slug,
              }))
            );
          } else {
            const data = await getVenues();
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=venue" + "&subcategory=" + val.slug,
              }))
            );
          }
          break;
        case "Vendors":
          if (vendors?.length > 0) {
            setNavigation(
              vendors?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=" + val?.slug,
              }))
            );
          } else {
            const data = await getVendors();
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?category=" + val?.slug,
              }))
            );
          }
          break;
        case "Find by Cast":
          if (cast?.length > 0) {
            setNavigation(
              cast?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?cast=" + val?.slug,
              }))
            );
          } else {
            const data = await getCommunities("cast");
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?cast=" + val?.slug,
              }))
            );
          }
          break;
        case "Plan by Events":
          if (event?.length > 0) {
            setNavigation(
              event?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?event=" + val?.slug,
              }))
            );
          } else {
            const data = await getCommunities("event");
            setNavigation(
              data?.data?.map((val, index) => ({
                key: index,
                name: val?.name,
                link: "/vendors?event=" + val?.slug,
              }))
            );
          }
          break;
        default:
          setNavigation([]);
          break;
      }
    })();
  }, [nav]);

  return (
    <List className="w-100">
      {item &&
        item?.link.map((val) => (
          <List.Item>
            <NavLink className="header-drawer-nav-link" to={val?.link}>
              {val?.name}
            </NavLink>
          </List.Item>
        ))}
      {navigation.map((val) => (
        <List.Item>
          <NavLink className="header-drawer-nav-link" to={val?.link}>
            {val?.name}
          </NavLink>
        </List.Item>
      ))}
    </List>
  );
};
